import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IOqcValidationResultContract } from '../models/domain/oqc-validation-result';

@Injectable({
  providedIn: 'root',
})
export class OqcValidationService {
  public constructor(private readonly httpClient: HttpClient) {}

  public validateOqc(designId: string): Observable<IOqcValidationResultContract> {
    return this.httpClient.get<IOqcValidationResultContract>(
      `api/validation/${designId}/oqc/errors`
    );
  }
}
